import React from "react";
import { motion } from "motion/react";

export const TestimonialsColumn = (props) => {
  return (
    <div className={props.className}>
      <motion.div
        animate={{
          translateY: "-50%",
        }}
        transition={{
          duration: props.duration || 10,
          repeat: Infinity,
          ease: "linear",
          repeatType: "loop",
        }}
        className="flex flex-col"
        style={{ willChange: "transform" }}
      >
        {[1, 2].map((set) => (
          <div key={set} className="flex flex-col gap-6 pb-6 items-center">
            {props.testimonials.map(({ text, image, name, role }, i) => (
              <div
                className="liquid-glass p-8 rounded-3xl max-w-xs w-full shadow-lg"
                style={{ 
                  backdropFilter: "none", 
                  WebkitBackdropFilter: "none", 
                  backgroundBlendMode: "normal", 
                  background: "rgba(255, 255, 255, 0.05)" 
                }}
                key={i}
              >
                <p className="text-white/80 font-body font-light text-sm leading-relaxed mb-6">
                  "{text}"
                </p>
                <div className="flex items-center gap-3">
                  <img
                    width={40}
                    height={40}
                    src={image}
                    alt={name}
                    className="h-10 w-10 rounded-full"
                    loading="lazy"
                  />
                  <div className="flex flex-col">
                    <div className="font-medium font-body text-white text-sm tracking-tight leading-5">
                      {name}
                    </div>
                    <div className="leading-5 font-body text-white/50 text-xs tracking-tight">
                      {role}
                    </div>
                  </div>
                </div>
              </div>
            ))}
          </div>
        ))}
      </motion.div>
    </div>
  );
};
